import $ from "jquery";
import 'slick-carousel';

const logo_wall = function () {
  const selector = '.js-logo-wall';

  $(selector).slick({
    lazyLoad: 'ondemand',
    'dots': false,
    'arrows': true,
    'infinite': true,
    'slidesToShow': 1,
    'slidesToScroll': 1,
    mobileFirst: true,
    nextArrow: '<button type="button" class="slick__next material-icons">keyboard_arrow_right</button>',
    prevArrow: '<button type="button" class="slick__prev material-icons">keyboard_arrow_left</button>',
    'responsive': [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        },
      },
    ],
  });
};

export default logo_wall;


